export default __webpack_public_path__ + "static/media/left_control.3e004e70.svg";